/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiagnosisClassificationEnum } from './diagnosisClassificationEnum';
import { DiagnosisCertaintyEnum } from './diagnosisCertaintyEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientDiagnosisSummary { 
    readonly id: number;
    code: string;
    description: string;
    classification: DiagnosisClassificationEnum;
    certainty: DiagnosisCertaintyEnum;
    readonly certaintySuffix: string;
}
export namespace PatientDiagnosisSummary {
}

export const PatientDiagnosisSummary_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisSummary_code_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisSummary_description_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisSummary_classification_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisSummary_certainty_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisSummary_certaintySuffix_Validators: ValidatorFn[] =
    [  Validators.required, ];


